<template>

  <div style="overflow-y: auto;">
        <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="height:200vh"
        variant="dark"
        id="loader"
      >
      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>স্বেচ্ছামূলক লোড ঘোষণা আবেদন</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <div>
            <!-- comment -->
            <b-tabs card fill>
                <b-tab title="স্বেচ্ছামূলক লোড ঘোষণা আঁচনিৰ বাবে আবেদন কৰক" active>

                <div style="padding-left:30px;  ">

                  <b-row style="padding-top: 0px;">
                        <b-col col cols="12" sm="3" md="3" lg="2" style="padding-top: 7px;">
                              <span style="font-weight:600" >উপভোক্তা নম্বৰ <span class="text-danger">*</span></span>
                        </b-col>
                        <b-col col cols="8" sm="3" md="8" lg="4">
                            <b-form-input type="text" maxlength="12" value="" id="consumerNumber" placeholder="আপোনাৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক" autocomplete="off" trim required />
                        </b-col>
                        <b-col col cols="4" sm="3" md="3" lg="1">
                            <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                              <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                            </b-button>
                        </b-col>
                      </b-row>
                <br>


              <div id="UserDetails" class="userDetails marginRight30px" >
                <b-row>
                  <b-col cols=12>
                      <span class="heading">ব্যৱহাৰকাৰীৰ বিৱৰণ</span>
                  </b-col>
                </b-row>
                <hr/>
                <br>

                  <b-row>
                    <b-col col cols="5" sm="2" md="2" lg="3">
                        <span class="label"> উপভোক্তা নাম : </span>
                    </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3">
                      <span id="consName" ></span>
                      </b-col>

                    <b-col col cols="5" sm="2" md="2" lg="3" class="marginTop10px">
                      <span class="label">উপবিভাগ : </span>
                    </b-col>
                        <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                        <span id="subDiv" ></span>
                      <br>
                    </b-col>
                  </b-row>
                  <br>

                  <div id="">
                  <b-row>
                    <b-col col cols="5" sm="2" md="2" lg="3">
                         <span class="label">ম'বাইল নম্বৰ  <span class="text-danger">*</span></span> :
                    </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3">
                      <b-form-input type="text" id="mobile"  placeholder="ম'বাইল নম্বৰ প্ৰবিষ্ট কৰক" style="width: 50%;"  disabled>
                       </b-form-input>
                      </b-col>
                    <b-col col cols="5" sm="2" md="2" lg="3" class="marginTop10px">
                       <span class="label">ইমেইল আইডি : </span> :
                   </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                      <b-form-input type="text" id="email"  placeholder="ই-মেইল আইডি প্ৰবিষ্ট কৰক  " disabled>
                       </b-form-input>
                  </b-col>

                </b-row>
                <br>
                <b-row> 

               
               <b-col col cols="5" sm="2" md="2" lg="3"  class="marginTop10px">
                   <span class="label">শুল্ক শ্ৰেণী </span> :
               </b-col>
               <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px" >
                  <span id="tariffCat" ></span>
              </b-col>
                </b-row>

                  <br>
                  <b-row>
                    <b-col col cols="5" sm="2" md="2" lg="3"  class="marginTop10px">
                       <span class="label">বৰ্তমান সংযোজিত লোড (কিলো ৱাট) </span> :
                   </b-col>
                   <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px" >
                      <span id="connectedLoad" ></span>
                  </b-col>
                  <b-col col cols="5" sm="2" md="2" lg="3"  class="marginTop10px">
                     <span class="label">লোড প্ৰয়োগ কৰা হৈছে(কিলো ৱাট) </span> :
                 </b-col>
                 <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px" >
                        <b-form-input type="number" id="appliedLoad"  placeholder="প্ৰয়োগ কৰা লোড প্ৰবিষ্ট কৰক" @keyup="showWarning()"  >
                     </b-form-input>
                     <span class="text-danger" id ="warning" style="font-size:0.8rem;display:none" >সতৰ্কবাৰ্তা: মিটাৰ পৰিৱৰ্তন ব্যয় যোগ কৰা হ'ব পাৰে</span>
                </b-col>
                </b-row>

                <br>
                <b-row>
                  <b-col col cols="5" sm="2" md="2" lg="3"  class="marginTop10px">
                     <span class="label">বকেয়া পৰিমাণ (টকা) </span> :
                 </b-col>
                 <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px" >
                    <span id="outstanding" ></span>
                </b-col>
                <b-col col cols="5" sm="2" md="2" lg="3"  class="marginTop10px">
                   <span class="label">অন্তিম পৰিশোধ তাৰিখ </span> :
               </b-col>
               <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px" >
                  <span id="lastPaymentDate" ></span>
              </b-col>
              </b-row>
              <br>
                  <b-row>
                    <b-col col cols="12" sm="12" md="12" lg="12">
                      <b-form-checkbox
                         id="checkbox"
                         v-model="status"
                         name="checkbox"
                         value="accepted"
                         unchecked-value="not_accepted"

                       >
                      <div style="text-align:justify">
                        মই,  <span class="declaration">{{ consName}} </span> বা অনুমোদিত প্ৰতিনিধিয়ে ইয়াৰ দ্বাৰা ঘোষণা কৰোঁ যে ওপৰত উল্লেখ কৰা সংযোজিত লোডমোৰ সৰ্বশ্ৰেষ্ঠ জ্ঞানঅনুসৰি শুদ্ধ আৰু মই এই উদ্দেশ্যৰ বাবে বলবৎ থকা নিয়ম আৰু নিয়মাৱলী মানি চলিম।
                        <br>
                        মই , <span class="declaration">{{ consName}} </span> বা অনুমোদিত প্ৰতিনিধিয়ে লগতে প্ৰতিশ্ৰুতি দিছোঁ যে মোৰ চৌহদত বৈদ্যুতিক স্থাপন (আভ্যন্তৰীণ ৱায়াৰিং ইত্যাদি সহ) পৰ্যাপ্ত ভাৱে ৰক্ষণাবেক্ষণ কৰা হয় আৰু প্ৰয়োগ কৰা অনুসৰি বৰ্ধিত লোড নিয়ন্ত্ৰণ কৰিবলৈ সক্ষম। সঠিক সুৰক্ষা নিশ্চিত কৰিবলৈ আৰু যিকোনো অপ্ৰীতিকৰ ঘটনা পৰিহাৰ কৰিবলৈ মই মোৰ চৌহদত বৈদ্যুতিক স্থাপন (আভ্যন্তৰীণ ৱায়াৰিং ইত্যাদি) প্ৰয়োজনীয় উন্নীতকৰণ কৰিম।
                        <br>
                        মই ,<span class="declaration">{{ consName}} </span> বা অনুমোদিত প্ৰতিনিধিয়ে লগতে প্ৰতিশ্ৰুতি দিছোঁ যে মোৰ চৌহদত অপৰ্যাপ্ত বৈদ্যুতিক স্থাপন (আভ্যন্তৰীণ ৱায়াৰিং ইত্যাদি)ৰ ফলত যিকোনো অপ্ৰীতিকৰ ঘটনা/দুৰ্ঘটনা সংঘটিত হ'লে, যিকোনো ফ'ৰামৰ আগত যিকোনো কাৰ্যক্ৰমৰ পৰা এপিডিচিএল কৰ্তৃপক্ষক ক্ষতিপূৰণ দিম।
                        <br>
                        মই, <span class="declaration">{{ consName}} </span>  বা অনুমোদিত প্ৰতিনিধিয়ে ট্ৰেন্সফৰ্মাৰৰ তত্বাৱধান আৰু বৈচিত্ৰ্যকাৰকৰ সৈতে লোডৰ ন্যায়সঙ্গত ব্যৱহাৰ,ট্ৰেন্সফৰ্মাৰৰ সুৰক্ষা সীমাৰ ভিতৰত ভালদৰে লম। (কেৱল ২৫ কেভিএ ক্ষমতাৰ নিৰ্দিষ্ট ট্ৰেন্সফৰ্মাৰ থকা গ্ৰাহকৰ বাবে প্ৰযোজ্য)।
                        
                        <br>
                        মই,  <span class="declaration">{{ consName}} </span>  বা অনুমোদিত প্ৰতিনিধিয়ে এপিডিচিএলক  পৰৱৰ্তী বিলিং চক্ৰৰ পৰা প্ৰযোজ্য শুল্ক অনুসৰি অতিৰিক্ত লোডৰ মাচুল ল'বলৈ  অনুমোদন দিওঁ
                        ।
                        <br>
                        মই,  <span class="declaration">{{ consName}} </span> 
                         বা অনুমোদিত প্ৰতিনিধিয়ে এপিডিচিএললৈ প্ৰদান কৰিবলগীয়া সকলো বাবদ ধন ক্লিয়াৰ কৰিছো আৰু আজিৰ তাৰিখ অনুসৰি কোনো ধনৰাশি প্ৰদান কৰিবলগীয়া হোৱা নাই।
                        <br>
                        মই, <span class="declaration">{{ consName}} </span> 
                       বা অনুমোদিত প্ৰতিনিধিয়ে এ.পি.ডি.চি.এল.ক মোৰ আৰু মোৰ আন যিকোনো স্থাপনৰ বিৰুদ্ধে যিকোনো বলপূৰ্বক পদক্ষেপ (আইনী ব্যৱস্থা, যোগান বিচ্ছিন্ন কৰা সহ) ল'বলৈ কৰ্তৃত্ব প্ৰদান কৰোঁ যদি ভৱিষ্যতে মোৰ ওপৰোক্ত প্ৰতিশ্ৰুতিত কোনো বিচ্যুতি পোৱা যায়।
                      </div>
                      </b-form-checkbox>

                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4" >
                তাৰিখ আৰু সময়: <span id="dateTime">test</span>
                    </b-col>

                  </b-row>
                    <br>
                  <b-row>
                    <b-col col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4">
                        <b-button block squared variant="primary"  id="button"  @click="sendOtp()">
                          দাখিল কৰক</b-button>
                         <br>
                    </b-col>

                  </b-row>

              </div>
              </div>

            </div>
          </b-tab>  

          <!-- comment -->

              <b-tab title="আবেদনৰ স্থিতি পৰীক্ষা কৰক">
                <b-row>
                      <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                            <span style="font-weight:600" >উপভোক্তা নম্বৰ  <span class="text-danger">*</span></span>
                      </b-col>
                      <b-col col cols="8" sm="8" md="8" lg="4">
                          <b-form-input type="text"  id="consNo" value=""  placeholder="আপোনাৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক" trim required />
                      </b-col>
                      <b-col col cols="4" sm="3" md="3" lg="1">
                            <b-button @click="checkStatus" block pill variant="primary" size="md" class="go" style="width:100%">
                              <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                            </b-button>
                      </b-col>
                 </b-row>

                 <div id="statusDetails" class="userDetails">
                   <hr>
                       <b-row>
                         <b-col cols=12>
                           <div id="applDetails"  style="width:92vw;font-size:0.8rem">
                               <span class="heading"> আবেদনৰ বিৱৰণ </span>
                               </br></br>
                               <b-table bordered responsive :items="applDetails" :fields="applDetailsFields">
                                 <template v-slot:cell(bill)="data">
                                  <span v-html="data.value"></span>
                                 </template>
                                 <template v-slot:cell(paymentLink)="data">
                                  <span v-html="data.value"></span>
                                 </template>
                               </b-table>
                           </div>
                         </b-col>
                       </b-row>
                     </div>

              </b-tab>

            </b-tabs>
        </div>

  </b-container>
  <br>


  <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
    <b-overlay
    :show="show1"
    spinner-variant="primary"
    spinner-large
    rounded="sm"
    style=""
    variant="dark"
    id="loader"
  >
       আপোনাৰ ম'বাইল নম্বৰত প্ৰাপ্ত অ'টিপি প্ৰবিষ্ট কৰক:
    <b-form-input type="number" id="otp" ></b-form-input><br>
    <b-button class="btn" variant="primary" id="success-btn" @click="SubmitApplication()" >Verify</b-button> &nbsp&nbsp
    <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
  </b-overlay>
</b-modal>


  <b-modal id="successModal" centered no-close-on-esc no-close-on-backdrop scrollable  hide-footer hide-header :static="true">

    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
    </svg>
    <p class="success">ভিএলডি আবেদন সফলতাৰে দাখিল কৰা হৈছে!
      <br>
      <span  style="font-size:1.2rem;color:black">Application No : <span id="applicationNo">test</span></span>
      <br>
      <span style="font-size:0.9rem;color:grey">(অনুগ্ৰহ কৰি ভৱিষ্যতৰ প্ৰসংগৰ বাবে আবেদন নম্বৰটো মনত ৰাখিব)</span>
      <br><br>
      <b-button @click="downloadReceipt()" class="btn btn-outline" variant="primary">Download Receipt</b-button>
      &nbsp
      <b-button @click="reloadPage()" class="btn btn-outline" variant="success">OK</b-button>

    </p>
  </b-modal>

  <b-modal id="failureModal" centered scrollable hide-footer hide-header no-close-on-esc no-close-on-backdrop :static="true">
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
    </svg>
    <span style="color:red" id="errorMsg"></span>
    <br>
      <b-button @click="reloadPage()" class="btn btn-outline" variant="danger">OK</b-button>
  </b-modal>


  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg">  </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal('model')">OK</b-button>
  </b-modal>
</b-overlay>
  </div>

</template>


<script>
import axios from 'axios';
import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
const numWords = require('num-words');
var CryptoJS = require("crypto-js");
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { enc } from 'crypto-js/core';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

var consNo= "";
var oldMob="";
var email ="";
// var aadhaar = "";
var appliedLoad ="";
var categoryCode = "";
var categoryName = "";
var connectedLoad = "";
var meterReq = "No";
var consName="";
var subDiv = "";
var subDivName = "";
var mobile="";
var outstandingAmt="";
var encAdhar="";
var thColor = '#0288d1';
var applNo="";
var esdNo="";

//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
export default {
  name: 'ConsReg',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
        value: '',
        show: false,
        show1: false,
        show2 : false,
        consNumber: "",
        status: 'not_accepted',
        consName:'',
        consNo:'',
        applNumber :'',
        categoryList : [],
        applDetailsFields: [
          { key: 'applNo', label: 'Application No',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'consNo', label: 'Consumer no',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'consName', label: 'Consumer Name',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'applied_load', label: 'Applied Load',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'category', label: 'Category',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'applStatus', label: 'Application Status',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'bill', label: 'Bill View',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'paymentLink', label: 'Payment',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },

        ],
        applDetails : [],
        }
  },
  methods: {
    reloadPage()
    {
      window.location.reload();
      window.scrollTo({ top: 0});
    },

  showDetails() {
    consNo= document.getElementById("consumerNumber").value;
    this.consNumber=consNo;
    // alert(consNo)
    // document.getElementById('consNo').innerHTML = consNo;
    if(consNo=="" || consNo.length<12)
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("mobNo").focus();
       return;
      }

      document.getElementById("appliedLoad").value = "";
      this.status="not_accepted";
      document.getElementById("warning").style.display="none";

    var parent=this;
    this.show= true;
   axios.post(this.$urlArms+'/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
      .then((response) => {
        parent.show= false;
      document.getElementById("UserDetails").classList.add("showUserDetails");

      // console.log(response.data);
      var data=response.data;
      var status = data.message;
      var mobileNum="";
      var emailID="";
      var temp1="";
      var temp2="";
      var lenMail=";"
       if(status=="00")
       {
         categoryCode = data.category_CODE;
         consNo=data.cons_no;
         consName=data.cons_name;
         subDiv = consNo.substring(0, 3);
         subDivName = data.subDivisionName;
         categoryName= data.category_NAME;
         document.getElementById("consName").innerHTML = data.cons_name;
         document.getElementById("subDiv").innerHTML = data.subDivisionName;
         document.getElementById("tariffCat").innerHTML = data.category_NAME;
         document.getElementById("connectedLoad").innerHTML = data.connected_LOAD;
         connectedLoad =  data.connected_LOAD;
         outstandingAmt = data.outStanding;
         document.getElementById("outstanding").innerHTML = data.outStanding;
         document.getElementById("lastPaymentDate").innerHTML = data.paymentDate;
         mobileNum = data.mobile_no;
         mobile = mobileNum;
         if(mobileNum){
          temp1 = mobileNum.substring(0,2);
          temp2 = mobileNum.substring(8,10);
          mobileNum=temp1+'******'+temp2;
          document.getElementById("mobile").value = mobileNum;
          // console.log("mobile number:::::::"+mobileNum);
          // return;
         }
         else{
              this.$bvToast.toast('Kindly update mobile number before proceeding !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("mobile").focus();
            return
         }
        
         emailID = data.email;
         if(emailID){
          lenMail = emailID.length;
          temp1 = emailID.substring(0,3);
          temp2 = emailID.substring(lenMail-3,lenMail);
          emailID = temp1+'**********'+temp2;
          document.getElementById("email").value = emailID;
         }
         else{
          document.getElementById("email").value = "NA";
         }
         
        //  console.log("mobile::::::"+mobileNo);
       //ocument.getElementById("aadhaar").value = data.aadhar_NO;
        //  if (data.aadhar_NO== null || data.aadhar_NO=="")
        //  document.getElementById("aadhaar").placeholder = "Enter Aadhar No";
        //  else
        //  document.getElementById("aadhaar").placeholder = "UPDATED";

         parent.consName = data.cons_name;

          document.getElementById("dateTime").innerHTML =  new Date().toLocaleString();


       }
       else{
         parent.$bvModal.show('model');
         document.getElementById("modalMsg").innerHTML="Sorry, Consumer Not Found";
         document.getElementById("UserDetails").classList.remove("showUserDetails");
       }

    })
    .catch((e) => {
    // console.log("Caught", e);
    parent.$bvModal.show('model');
    document.getElementById("modalMsg").innerHTML="Sorry, Consumer Not Found";
    document.getElementById("UserDetails").classList.remove("showUserDetails");
    this.show= false;
  })


},
showWarning()
{

  appliedLoad = document.getElementById("appliedLoad").value;
  // console.log(appliedLoad);
  if (parseFloat(appliedLoad) > 30) {
    this.$bvToast.toast('The applied load must not exceed 30 kW !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
    document.getElementById("appliedLoad").focus();
    return;
  }
  else if(parseFloat(appliedLoad) >= 5 && parseFloat(connectedLoad) < 5)
  {
    meterReq="Yes";
    document.getElementById("warning").style.display="block";

    // this.$bvModal.show('model');
    // document.getElementById("modalMsg").innerHTML="WARNING : Meter Change Cost may be Added";

  }
  else {
    meterReq="No";
    document.getElementById("warning").style.display="none";
  }

},
sendOtp()
{
  var parent =this;
  // mobile = document.getElementById("mobile").value;
  // email = document.getElementById("email").value;
  // aadhaar = document.getElementById("aadhaar").value;
  appliedLoad = document.getElementById("appliedLoad").value;

  // if(aadhaar==""){
  //   encAdhar = "NA";
  //   console.log("encAdhar:"+encAdhar);
  // }
  // else{
  //   encAdhar = CryptoJS.AES.encrypt(aadhaar, "U@M@A&N#G$-A#P%d&u@c-h1_e@r$r%l#");
  //   console.log("encAdhar:"+encAdhar);
  // }
  
  // encAdhar = CryptoJS.AES.encrypt(aadhaar, "U@M@A&N#G$-A#P%d&u@c-h1_e@r$r%l#");
  // console.log("encAdhar:"+encAdhar)
/* this.categoryList.forEach(element => {
  var res = element.category_CODE.split('-')
    console.log(res[0])
    if(categoryCode == res[0])
    {
        console.log("Matched=="+categoryCode)
       if(parseInt(appliedLoad) > parseInt(element.higher_LOAD_KW))
       {
         console.log("Meter Change")
       }
    }
}) */

  if (parseFloat(appliedLoad) > 30) {
      this.$bvToast.toast('The applied load must not exceed 30 kW !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
      document.getElementById("appliedLoad").focus();
      return;
    }
  // check the category code

  else if(categoryCode<="53" || categoryCode=="72" || categoryCode =="75")
    {
      // console.log("Category_code::::::", categoryCode);
      
      // console.log("Amount--"+outstandingAmt)
      if(parseInt(outstandingAmt)>0)
      {

       this.$bvModal.show('model');
       document.getElementById("modalMsg").innerHTML="You have outstanding bill amount of <strong>Rs. "+outstandingAmt+"</strong><br>VLD application is not allowed with outstanding bill amount.<br> Please pay your outstanding bill to apply for VLD.";
        return
       }
      if(parseInt(appliedLoad)<=parseInt(connectedLoad))
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Connected load and applied load can not be less than or same !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("appliedLoad").focus();
        return
      }
      if(parseInt(appliedLoad)==0)
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Applied load can not be zero !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("appliedLoad").focus();
        return
      }
      // console.log(mobile);
      // return
      var mobregx = /^[5-9]\d{9}$/
      if(!mobregx.test(mobile))
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("mobile").focus();
        return
      }


    //  var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    //   if(!emailRegex.test(email) && email!="")
    //   {
    //     // document.getElementById('failure-btn-mob').click();
    //     this.$bvToast.toast('Enter Valid Email !', {
    //       title: `Alert`,
    //       variant: 'danger',
    //       solid: true
    //     })
    //     document.getElementById("email").focus();
    //     return
    //   }
      // var aadhaarRegex =  /^\d{12}$/;
      // if(!aadhaarRegex.test(aadhaar) && aadhaar!="")
      //   {
      //     // document.getElementById('failure-btn-mob').click();
      //     this.$bvToast.toast('Enter Valid 12 digit Adhaar Number !', {
      //       title: `Alert`,
      //       variant: 'danger',
      //       solid: true
      //     })
      //     document.getElementById("aadhaar").focus();
      //   return
      //   }

      if(appliedLoad=="")
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter Applied Load !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("appliedLoad").focus();
      return
      }



      if(this.status=== "not_accepted" )
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Please Accept Declaration !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("checkbox").focus();
      return
      }


      parent.show= true;
      axios.post("https://www.apdcl.org/website/api/generateOtp?mobNo="+mobile).then(function(response) {
        // console.log(response.data);
        parent.show= false;
        if (response.data.message == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
          parent.$bvModal.show('otpModal');

        }
      });
      
    }
    else{
      this.$bvModal.show('model');
      document.getElementById("modalMsg").innerHTML="Consumer belonging to category "+categoryName+"</strong> is not allowed to apply for VLD.";
      return;
    }
},

closeModal(modalId){
  this.$bvModal.hide(modalId)
},
resendOtp()
{
  var parent =this;
  var mobile = document.getElementById("mobile").value;
  parent.show1= true;
  axios.post("https://www.apdcl.org/website/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
    parent.show1= false;
    if (response.data.message == "success") {
      parent.$bvToast.toast('OTP Sent Successfully !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
    }
  else {
      parent.$bvToast.toast('OTP Could not Sent !', {
        title: `danger`,
        variant: 'danger',
        solid: true
      });
    }
  });
},

SubmitApplication(){
  
      var otp = document.getElementById("otp").value;
      // var mobile = document.getElementById("mobile").value;
      // console.log(mobile);
      // return;

    var parent=this;


var mobregx = /^[5-9][0-9]{9}$/
if(!mobregx.test(mobile))
  {

    this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
      title: `Alert`,
      variant: 'danger',
      solid: true
    })
  return
  }


     if(otp=="")
        {

          this.$bvToast.toast('Enter OTP !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
        return
        }

      parent.show1= true;

      axios.post("https://www.apdcl.org/website/api/validateOtp?mobNo="+mobile+"&otpNo="+otp).then(function(response)
      {

        if (response.data.message == "VALID") {

            parent.$bvToast.toast('OTP Successfully Verified !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
          var parent2=parent;
             var data = "NA";
             encAdhar = CryptoJS.AES.encrypt(data, "U@M@A&N#G$-A#P%d&u@c-h1_e@r$r%l#");
            //  if(encAdhar=="NA"){
              
            //  } 
            //  else{
              data = encAdhar.toString();
            //  }
             var config = {
               method: 'post',
               url: parent2.$urlArms+"/RestAPI/applyVLDOnline?subDiv="+subDiv+"&consNo="+consNo+"&appliedLoad="+appliedLoad+"&isMeterReq="+meterReq+"&mobNo="+mobile+"&consName="+consName+"&email="+email,
               headers: {
                 'Content-Type': 'text/plain'
               },
               data : data
             };
             axios(config)
             .then(function (response) {
                  parent2.show1= false;
              //  console.log(JSON.stringify(response.data));
               if (response.data.msg == "success") {
                   parent2.$bvModal.show('successModal');
                   document.getElementById("applicationNo").innerHTML=response.data.applNo
                   applNo = response.data.applNo;
               }
               else {

                   parent2.$bvModal.show('failureModal');
                   document.getElementById("errorMsg").innerHTML=response.data.errorMsg1;

               }
             })
             .catch(function (error) {
               console.log(error);
             });
        }
        else{
          parent.show1= false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Invalid OTP";
        }

      });

    },
    checkStatus()
    {
      var consNo=document.getElementById("consNo").value;
      if(consNo=="" || consNo.length<12)
      {
        this.$bvToast.toast('12 টা সংখ্যাৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })

        return;
    }
var temp = [];
      var parent=this;
      this.show= true;
      axios.post(parent.$urlArms + "/RestAPI/getVldStatus?consNo="+consNo)
      .then((response) => {
        parent.show= false;
        // console.log(response.data);
        // console.log("length=="+response.data.length);
        if(response.data.length==0)
        {
          document.getElementById("statusDetails").classList.remove("showUserDetails");
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="এই উপভোক্তাৰ বাবে ভিএলডি এপ্লিকেচন পোৱা নগ'ল";
          return;
        }
        document.getElementById("statusDetails").classList.add("showUserDetails");
        var billview = "NA";
        var payment = "NA";
        response.data.forEach(element => {

          if (element.applStatusId == 1005 ||element.applStatusId == 1006 || element.applStatusId == 1007)
          {
            billview = "<a href='"+ element.document+"' target='_blank'> View Bill </a>";
          }
          if (element.applStatusId == 1005)
          {
            payment = "<a href='"+ element.paymentLink+"' target='_blank'> Payment Link </a>"
          }
          if (element.applStatusId == 1006 || element.applStatusId == 1007)
          {
            payment = "<a href='"+ element.paymentLink+"' target='_blank'> Payment Receipt </a>"
          }
          
          var obj = {
          "applNo" :  element.applNo,
          "consNo" :  element.consNo,
          "consName" :  element.consName,
          "applied_load" :  element.connected_load,
          "category" :  element.category_code_name,
          "applStatus" :  element.applStatus,
          "bill" : billview,
          "paymentLink" : payment
           }
         temp.push(obj);
        })
        parent.applDetails = temp;

      })

    },
    downloadReceipt() {
            esdNo = consNo;
            var digits = esdNo.toString().split('');
            var realDigits = digits.map(Number);
            var esd1 = realDigits[0];
            var esd2 = realDigits[1];
            var esd3 = realDigits[2];
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();

            today = dd + '/' + mm + '/' + yyyy;
            var docDefinition = {
            pageSize: 'A5',
            pageOrientation: 'portrait',
            content: [
              // { image: '../assets/apdcl_logo.png',  width: 150,  height: 150,},
              { text: 'ACKNOWLEDGEMENT RECEIPT', style: 'header' },
              // { text: 'AMICABLE ONE-TIME SETTLEMENT SCHEME', style: 'header' },
              { text: 'Voluntary Load Declaration Scheme, APDCL', style: 'subheader' },
              { text: 'Reg. No: VLD/2023/'+esd1+esd2+esd3+'/'+applNo, style: 'esdNo' },
              { text: 'Application No: '+applNo, style: 'applNo' },
              { text: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -' },

              { text: 'Application Details:', style: 'heading' },
              { text: ['Consumer No: ', {text: consNo , style: 'boldText'},], style: 'normalText' },
              {	text: ['Name of the Consumer: ',	{text:consName , style: 'boldText'}, ],style: 'normalText'},
              { text: ['Category name: ', {text: categoryName , style: 'boldText'},], style: 'normalText' },
              { text: ['Subdivision: ', {text: subDivName, style: 'boldText'},], style: 'normalText' },
              { text: ['Connected Load: ', {text: connectedLoad +" KW", style: 'boldText'},], style: 'normalText' },
              { text: ['Applied Load: ', {text: appliedLoad+" KW", style: 'boldText'},], style: 'normalText' },
              { text: '\nNote: Execution of the same is subject to compliance of all applicable terms and conditions and need based physical verification of the consumer installation to the satisfaction of the authority.', style: 'normalText' },
              { text: ['\nDate: '+today,{text: '\t\t\t\t\t\t\t\t\t\t\t\t\tAuthorized signatory', style: 'boldText'}], style: 'normalText'},
              { text: '\n * * This is a system generated statement and no signature is required * * ', style: 'footerText'},
                 ],
                 styles: {
                      header: {
                      fontSize: 15,
                      bold: true,
                      alignment: 'center',
                      margin: [0, 0, 0, 5]
                  },
                subheader: {
                    fontSize: 15,
                    alignment: 'center',
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                applNo: {
                    fontSize: 13,
                    alignment: 'center',
                    color: '#0277bd',
                    margin: [0, 10, 0, 5]
                },
                esdNo: {
                    fontSize: 10,
                    alignment: 'center',
                    fontWeight: 'bold',
                    // color: '#0277bd',
                    margin: [0, 10, 0, 5]
                },
                heading: {
                    fontSize: 12,
                    alignment: 'left',
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                normalText: {
                    fontSize: 10,
                    alignment: 'left',
                    margin: [0, 10, 0, 5],
                    width:10
                },
                boldText: {
                    fontSize: 11,
                    alignment: 'left',
                    bold:true,
                    margin: [0, 10, 0, 5]
                },
                bottomText: {
                    fontSize: 10,
                    fontWeight: 600,
                    alignment: 'left',
                    margin: [0, 10, 0, 5]
                },
                footerText: {
                    fontSize: 8,
                    alignment: 'center',
                    margin: [0, 10, 0, 5]
                },
                tableExample: {
                    margin: [0, 5, 5, 0],
                    alignment: 'left',
                    fontSize: 10,
                }
            },

          };

          pdfMake.createPdf(docDefinition).download("VLD_Receipt_" +consNo+ ".pdf");
          setTimeout(function(){ window.location.reload(); }, 2000);

        }

  },
  mounted()
  {

    // axios.post(this.$urlArms+ "/RestAPI/crm/getAllCategoryList").then(response =>
    //       {
    //           this.categoryList = response.data;
    //       })

  //  this.$bvModal.show('successModal');
  //  document.getElementById("applicationNo").innerHTML="12345"
  },

}
</script>

<style scoped="true">
.label{
font-weight: 600;
}
.data{
  font-weight: 500;
  color: #bf360c;
  font-size: 1.1rem;
}
.declaration
{
  color:#263238;
  font-weight:600;
}
.userDetails
{
  /* visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear; */
  display:none;
}
.showUserDetails
{
 /* visibility: visible;
 opacity: 1; */
 display:block;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.modalFont{
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}
p.success {
  color: #73AF55;
}
p.error {
  color: #D06079;
}
.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
  @media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .marginRight30px{
      margin-right: 30px !important;
    }
  }
  @media (max-width: 576px) {
    .marginTop10px{
      margin-top: 10px !important;
    }
  }

</style>

